module.exports = __webpack_public_path__ + "img/md.93e2999f.svg";